module.exports = __webpack_public_path__ + "img/a9.2d5759cd.jpg";